<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				新建小组
			</div>
		</div>
		<div class="form">
			<div class="form-item">
				<div class="title">
					<div>小组名称</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入小组名称" v-model="serveData.name"> <span style="margin: 0 15px;">@</span> <input disabled :value="serveData.nickname" style="width: 400px;" placeholder="请输入昵称" type="text">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>邮箱地址</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" v-model="serveData.email" placeholder="请输入"> 
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>联系电话</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text"  v-model="serveData.mobile"  placeholder="请输入"> 
				</div>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title">
					<div>简介</div>
					<span>:</span>
				</div>
				<div class="inp">
					<el-input
					id="textarea"
					   type="textarea"
					  placeholder="字数小于200字，如果留空，则显示“小组由XXX在2023年1 月20 日创建”"
					  v-model="serveData.content"
					  resize='none'
					  maxlength="200"
					  show-word-limit
					></el-input>
				</div>
			</div>
		</div>
		<div class="commit" @click="craateTeam">确认提交</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				jianjie:'',
				serveData:{
					name:'',//小组名称
					nickname:'',//昵称
					email:'',//邮箱
					mobile:'',//电话
					content:''
				}
			}
		},
		created() {
			this.serveData.nickname = this.$store.state.userInfo.nickname
		},
		methods:{
			async craateTeam(){
				if(this.serveData.content == ''){
					this.serveData.content = '该小组由'+this.$store.state.userInfo.nickname+this.timeConversion(new Date()/1000)+'创建'
				}
				const team = await this.$api.addGroupTeam({...this.serveData})
				if(team.code == 1){
					this.$message({
						message:team.msg,
						type:'success'
					})
					this.$router.go(-1)
				}else{
					this.$message({
						message:team.msg,
						type:'warning'
					})
				}
			}
			// addGroupTeam
		}
	}
</script>

<style lang="less" scoped>
	.commit {
		width: 261px;
		height: 40px;
		background: #0052D9;
		color: white;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
		line-height: 40px;
		margin: auto;
		text-align: center;
	}
	/deep/.el-textarea__inner{
		width: 893px;
		height: 198px;
		font-size: 18px;
	}
	.form {
		padding: 40px 50px;
		box-sizing: border-box;
	
		/deep/.el-select {
			margin-bottom: 20px;
		}
	
		/deep/.el-textarea__inner {
			border: 1px solid #D2D2D2;
			color: black !important;
			font-family: none;
		}
	
		/deep/.el-input__inner {
			width: 448px;
			border: 1px solid #D2D2D2;
			line-height: 45px;
			font-size: 18px;
			color: black !important;
			height: 45px;
			box-sizing: border-box;
		}
	
		/deep/.el-textarea__inner::placeholder,
		/deep/.el-input__inner::placeholder {
			color: #999999;
			font-size: 18px;
		}
	
		.form-item {
			display: flex;
			margin-bottom: 30px;
			align-items: baseline;
	
			.inp {
				margin-left: 40px;
	
				& input {
					font-size: 18px;
					padding: 0 15px;
					box-sizing: border-box;
					width: 448px;
					height: 45px;
					border: 1px solid #D2D2D2;
					border-radius: 6px;
					margin-bottom: 20px;
				}
			}
	
			.title {
				font-size: 18px;
				display: flex;
				align-items: center;
	
				&>div {
					width: 77px;
					text-align-last: justify;
				}
			}
		}
	}
	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
		background: #fff;
	}
</style>